// removed by extract-text-webpack-plugin
module.exports = {"blackout":"_2PecA2IrH53WDrsiTxfktu","spinner":"_2PiFkSIwYHDaM3DME1hkJR"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/LoadingScreen/style.scss
// module id = 962
// module chunks = 0